// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3mMrW","title":"Info_title__3aVqs","selects":"Info_selects__3OVNU","requiredAsterisk":"Info_requiredAsterisk__3SQC7"};